var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessCallout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#a7e2dc",
    d: "M.91 0l6.4 30 25.6-30",
    "data-name": "Layer 5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCallout);
export default __webpack_public_path__ + "static/media/success_callout.8ee7067fbce07e7fae8d211bc9dea6a6.svg";
export { ForwardRef as ReactComponent };